export default "__VITE_ASSET__D$DHEjMn__"